/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { Row, Col,  Table, Spin, message, Tag, Space, Modal, Button, Form, Input, Switch, } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useEffect, useReducer, useState } from 'react';
import { DatePicker } from 'antd';
import axios from 'axios';
import reducer from './reducer';
import { SCHEDULE_LIST_SUCCESS, SCHEDULE_LIST_ERROR, SCHEDULE_LIST, DELETE_SCHEDULE, DELETE_SCHEDULE_SUCCESS, DELETE_SCHEDULE_ERROR, SCHEDULE_DETAILS, SCHEDULE_DETAILS_ERROR, SCHEDULE_DETAILS_SUCCESS, SCHEDULE_UPDATE, SCHEDULE_UPDATE_SUCCESS, SCHEDULE_UPDATE_ERROR, ADD_SCHEDULE, ADD_SCHEDULE_SUCCESS, ADD_SCHEDULE_ERROR} from './constants';
import { useNavigate } from 'react-router-dom';
import {  EditOutlined, DeleteOutlined } from '@ant-design/icons';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useAuth } from '../Context';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import moment from 'moment';

export default function Schedule(props) {
    
    
    
	const { userId,  startDate, endDate , pipelineId, setShowScheduleAddModal, closeAddScheduleModal, showScheduleAddModal } = props;
	const initalState = { pending: false, error: false, schedule : [], pagination: { total: 0, limit: 10, skip: 0, current:1 },details : null};
	const [data, dispatch] = useReducer(reducer, initalState);
	const navigate = useNavigate();
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteScheduleModal, setShowDeleteScheduleModal] = useState(false);
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	useAuth();

	useEffect(() => {
		if(featuresModule == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4010);
	}, []);
    
    
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		loadSchedule(1);
        
	},[authtoken, startDate, endDate]);
    
    
	const dateTimeFromHandler = (date,options) =>{
		const isodate = date && date.$d.toISOString();
		if(options =='add'){
			addScheduleFormik.setFieldValue('datetimeFrom', isodate);
		}else if(options =='edit'){
			formik.setFieldValue('datetimeFrom', isodate);
		}
	};

	const dateTimeToHandler = (date,options)=>{
		const isodate = date && date.$d.toISOString();
		if(options=='add'){
			addScheduleFormik.setFieldValue('datetimeTo', isodate);
		}else if(options =='edit'){
			formik.setFieldValue('datetimeTo', isodate);
		}
	};
    
	const loadSchedule = (pagination) => {
		let _pagination = { };
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;
    
		dispatch({ type : SCHEDULE_LIST});		
        
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/loginschedulemanagement?userId=${parseInt(userId)}&$sort[id]=-1&$limit=${_pagination.limit}&$skip=${_pagination.skip}&pipelineId=${parseInt(pipelineId)}&datetimeFrom[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&datetimeFrom[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}`,
			timeout: timeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`
			}
		};
    
		axios.request(config)
			.then((response) => {
				
                    
				if ( response.status === 200) { 
					dispatch({ type : SCHEDULE_LIST_SUCCESS, payload : response.data, page:pagination.current, pageSize : pagination.pageSize });
                        
				} else { 
					dispatch({ type : SCHEDULE_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : SCHEDULE_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
    
	const showEditDrawer = () => {
		setOpenEditDrawer(true);
		
	};
	const openDeleteAssetsModal = () => {
		setShowDeleteScheduleModal(true);
	};
	
	const closeDeleteAssetsModal = () => {
		setShowDeleteScheduleModal(false);
	};
	const handleModalCancel = ()=>{
		setOpenEditDrawer(false);
	};
        

        
    
	const columns = [
		{
			title : langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex : 'name',
			key : 'name'
		},
		{
			title : langdata && langdata.TimeFrom ? langdata.TimeFrom : 'Time From',
			dataIndex : 'datetimeFrom',
			key : 'datetimeFrom'
		},
		{
			title : langdata && langdata.TimeTo ? langdata.TimeTo : 'Time To',
			dataIndex : 'datetimeTo',
			key : 'datetimeTo'
		},
		{
			title :  langdata && langdata.LatestSchedule ? langdata.LatestSchedule : 'Latest Schedule',
			dataIndex : 'latestSchedule',
			key : 'latestSchedule',
			render: (_, { latestSchedule }) => (
				<>
					<Tag
						color={
							latestSchedule ? 'green' : 'red'
						}
					>
						{latestSchedule ? langdata && langdata.Yes ? langdata.Yes : 'Yes' : langdata && langdata.No ? langdata.No : 'No' }
					</Tag>
				</>
			),
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: '',
			align:'center',
			render: () => (
				

				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={showEditDrawer}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteAssetsModal}><DeleteOutlined /></a>
					</Space>
				</>
			)
		}
                
            
	];

	const deleteSchedule = () => {
		const id = parseInt(data.details.id);
		
		dispatch({ type: DELETE_SCHEDULE });
	
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/loginschedulemanagement/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
	
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_SCHEDULE_SUCCESS, payload: response});
					setShowDeleteScheduleModal(false);   
					loadSchedule(1);       
				} else {
					dispatch({type:DELETE_SCHEDULE_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_SCHEDULE_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadScheduleDetails = ((record) => {
		
		dispatch( { type: SCHEDULE_DETAILS });
			
		if (!record) {
			dispatch({ type: SCHEDULE_DETAILS_ERROR });
		} else {
			dispatch({ type: SCHEDULE_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
			datetimeFrom: data?.details?.utcTimeFrom || '',
			datetimeTo: data?.details?.utcTimeTo || '',
			latestSchedule : data?.details?.latestSchedule ,
		},
		onSubmit: (values) => {
			if(values.datetimeFrom > values.datetimeTo){
				Modal.warning({ title: langdata && langdata.SelectValidDateTime ? langdata.SelectValidDateTime : 'Select Valid Date Time' });
				return false;
			}

			dispatch({type:SCHEDULE_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/loginschedulemanagement/${data.details.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					datetimeFrom : values.datetimeFrom,
					datetimeTo: values.datetimeTo,
					latestSchedule : values.latestSchedule,
					pipelineId : parseInt(pipelineId)
					
				}
			};
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: SCHEDULE_UPDATE_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.ScheduleUpdatedSuccessfully ? langdata.ScheduleUpdatedSuccessfully :'Schedule Updated Successfully'}` });
						formik.resetForm();
						setOpenEditDrawer(false);
						loadSchedule({current : parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_PAGE`)), skip : (parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_PAGE`)) - 1) * 10, pageSize : parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_PAGE_SIZE`))});
							
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: SCHEDULE_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});

	const handleToggle = (value)=>{
		formik.setFieldValue('latestSchedule',value);
	};
	const handleAddToggle = (value)=>{
		addScheduleFormik.setFieldValue('latestSchedule',value);
	};
    
	const addScheduleFormik = useFormik({
		// enableReinitialize: true,
		initialValues: {
			name:  '',
			datetimeFrom: new Date().toISOString(),
			datetimeTo: new Date().toISOString(),
			latestSchedule : false
		},
		onSubmit: (values) => {

			
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}

			if(values.datetimeFrom > values.datetimeTo){
				Modal.warning({ title: langdata && langdata.SelectValidDateTime ? langdata.SelectValidDateTime : 'Select Valid Date Time' });
				return false;
			}
			
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/loginschedulemanagement`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					datetimeFrom : values.datetimeFrom,
					datetimeTo: values.datetimeTo,
					latestSchedule : values.latestSchedule,
					pipelineId : parseInt(pipelineId),
					userId : userId
						
				}
			};
	
			dispatch( { type: ADD_SCHEDULE });
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_SCHEDULE_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.ScheduleAddedSuccessfully ? langdata.ScheduleAddedSuccessfully : 'Schedule Added Successfully' });
						setShowScheduleAddModal(false);
						addScheduleFormik.resetForm();
						loadSchedule(1);
					} else {
						dispatch({type: ADD_SCHEDULE_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToAddSchedule ? langdata.UnableToAddSchedule : 'Unable To Add Schedule' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_SCHEDULE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});
	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						<Table 
							scroll={{
								x: 900,
							}}
							columns={columns} dataSource={data.schedule} pagination = { data.schedule.length > 0 ? data.pagination : 0 } onChange={loadSchedule}
							onRow = {(record) => {
								return {
									onClick: () => { 
										loadScheduleDetails(record);
										
												
									}
								};
							}}
						/>
					</Col>
				</Row>


				{/* EDIT SCHEDULE MODAL  */}
				<Modal
					title={langdata && langdata.EditSchedule ? langdata.EditSchedule:'Edit Schedule'}
					width={800}
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={formik.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={formik.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={formik.handleSubmit} layout="vertical"
					
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<Input name="name" value={formik.values.name} onChange={formik.handleChange} defaultValue={data?.details?.name}  placeholder={langdata && langdata.Name ? langdata.Name:'Name'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.TimeFrom ? langdata.TimeFrom:'Time From'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeFrom}
										placeholder={langdata && langdata.PleaseEnterFromDate ? langdata.PleaseEnterFromDate : 'Please Enter From Date'}
										onChange={(date)=>{dateTimeFromHandler(date,'edit');}} 
										format = {settingsdateformat  + ' ' + settingstimeformat}	
										value={formik.values.datetimeFrom? dayjs(formik.values.datetimeFrom): null}		 showTime/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.TimeTo ? langdata.TimeTo:'Time To'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeTo}
										placeholder={langdata && langdata.PleaseEnterToDate ? langdata.PleaseEnterToDate : 'Please Enter To Date'}
										onChange={(date)=>{ dateTimeToHandler(date,'edit');}} format = {settingsdateformat  + ' ' + settingstimeformat} value={formik.values.datetimeTo? dayjs(formik.values.datetimeTo): null}	 showTime/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.LatestSchedule ? langdata.LatestSchedule:'LatestSchedule'} rules={[{ required: false}]}>
									<Switch size='small'  defaultValue={formik.values.latestSchedule} onChange={(value) => handleToggle(value)} />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>

				{/* DELETE SCHEDULE MODAL  */}
				<Modal 
					title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'}
					open={showDeleteScheduleModal}
					onOk={deleteSchedule}
					onCancel={closeDeleteAssetsModal}
					
				>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisSchedule ? langdata.AreYouSureYouWantToDeleteThisSchedule : 'Are You Sure You Want To Delete This Schedule' }</Col>
					</Row>
				</Modal>
				
				{/* ADD SCHEDULE MODAL  */}
				<Modal
					title={ langdata&&langdata.AddSchedule?langdata.AddSchedule:'Add Schedule' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showScheduleAddModal}
					onOk={closeAddScheduleModal}
					onCancel={closeAddScheduleModal}
					
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={closeAddScheduleModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addScheduleFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addScheduleFormik.handleSubmit}>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item  label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please enter  name' }]} >
									<Input name="name" onChange={addScheduleFormik.handleChange} placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} />
								</Form.Item>
							</Col>
						</Row>
				
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.TimeFrom ? langdata.TimeFrom : 'Time From'} rules={[{ required: true, message: langdata && langdata.PleaseEnterFromDate ? langdata.PleaseEnterFromDate : 'Please Enter From Date' }]} >
									{/* <Input name="addTaskAssignDate" onChange={addTasklistFormik.handleChange} placeholder={langdata && langdata.PleaseEnterAssignedDate ? langdata.PleaseEnterAssignedDate : 'Please enter assigned date' } /> */}
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeFrom}
										placeholder={langdata && langdata.PleaseEnterFromDate ? langdata.PleaseEnterFromDate : 'Please Enter From Date'}
										onChange={(date)=>{ dateTimeFromHandler(date, 'add');}} format = {settingsdateformat  + ' ' + settingstimeformat} showTime/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.TimeTo ? langdata.TimeTo : 'Time To'}   >
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeTo}
										placeholder={langdata && langdata.PleaseEnterToDate ? langdata.PleaseEnterToDate : 'Please Enter To Date'}
										onChange={(date)=>{ dateTimeToHandler (date,'add');}} format = {settingsdateformat  + ' ' + settingstimeformat} showTime/>			
									
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="latestSchedule" label={langdata && langdata.latestSchedule ? langdata.latestSchedule : 'Latest Schedule'}rules={[{ required: false}]} >
									{/* <Input name="addTaskDescription" onChange={addTasklistFormik.handleChange} placeholder={ langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter Description'} /> */}
									<Switch size='small'  onChange={(value) => handleAddToggle(value)} />
								</Form.Item>
							</Col>
						</Row>
				
															
					</Form>
				</Modal>
				<Spin fullscreen spinning={data.pending} />
			</Content>
		</>
	);
}

